import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-base border-y border-sand" data-id="element-139">
      <div className="container mx-auto px-4 text-center" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-forest/20" data-id="element-141">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-forest/10 text-forest mb-6 border border-forest/20" data-id="element-142">
            <ShieldCheck className="w-10 h-10" data-id="element-143" />
          </div>

          <h2 className="text-3xl font-extrabold text-forest-dark mb-4" data-id="element-144">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-muted mb-6" data-id="element-145">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas:
          </p>

          <div className="bg-forest/10 text-forest font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-forest/20" data-id="element-146">
            Devolución del 100% sin formularios, sin drama.
          </div>

          <p className="text-muted font-medium uppercase tracking-wider text-[12px]" data-id="element-147">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}